import React, { useState } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { ResponsiblePersonDetails, OrderObject } from 'common/types';
import { Typography, Box } from '@mui/material';
import { getAddressStringFromLocation } from 'common/utils/common';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useTranslation } from 'services/localization/useTranslation';
import { usePermissions } from 'hooks/usePermissions';

interface OwnProps {
	responsiblePerson: ResponsiblePersonDetails;
	rental: OrderObject;
	startEditingResponsiblePerson: () => void;
}

type Props = OwnProps;

export const ResponsiblePersonInformation = ({ ...props }: Props) => {
	const { responsiblePerson, rental } = props;
	const classes = useStyles();
	const [expanded, setExpanded] = useState(false);
	const { t } = useTranslation();
	const { hasPermission } = usePermissions();

	const getTitleName = () => {
		const { firstName, lastName, email, phone } = responsiblePerson;
		const rentalLink = rental.rentalInfo.rentalLink;

		const title = firstName
			? firstName + (lastName ? ' ' + lastName : '')
			: email
			? email
			: phone
			? phone
			: rentalLink
			? rentalLink.email
				? rentalLink.email
				: rentalLink.phone
			: 'no information';

		return title;
	};

	const responsiblePersonTitle = getTitleName();

	return (
		<div data-sl="mask">
			<Box className={classes.inline}>
				<Typography variant="h5" style={{ flexGrow: 1 }}>
					{responsiblePersonTitle}
				</Typography>
				{expanded ? (
					<KeyboardArrowUpIcon onClick={() => setExpanded(!expanded)} />
				) : (
					<KeyboardArrowDownIcon onClick={() => setExpanded(!expanded)} />
				)}
			</Box>
			{expanded ? (
				<Box>
					<Typography variant="body2" style={{ flexGrow: 1 }}>
						{responsiblePerson.phone}
					</Typography>
					<Typography variant="body2" style={{ flexGrow: 1 }}>
						{' '}
						{responsiblePerson.email}
					</Typography>
					{responsiblePerson.homeAddress ? (
						<Typography variant="body2" style={{ flexGrow: 1 }}>
							{getAddressStringFromLocation(responsiblePerson.homeAddress)}
						</Typography>
					) : null}
					{responsiblePerson.accommodation ? (
						<Typography variant="body2" style={{ flexGrow: 1 }}>
							{responsiblePerson.accommodation}
						</Typography>
					) : null}
					<Typography
						onClick={props.startEditingResponsiblePerson}
						className={classes.editInfo}
						variant="body2"
						hidden={!hasPermission('edit_booking')}
					>
						{t('editDetails', 'Edit details')}
					</Typography>
				</Box>
			) : null}
		</div>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		inline: {
			display: 'flex',
			alignItems: 'center',
		},
		editInfo: {
			width: 'fit-content',
			borderBottom: 'solid 1px ' + theme.palette.primary.main,
			color: theme.palette.primary.main,
			cursor: 'pointer',
		},
	}),
);

export default ResponsiblePersonInformation;
